import XAPPService from "app/Core/services/XAPPService";
export const GET_PROFISSIONAISEMPRESA = "[COMPARTILHAR APP] GET PROFISSIONAIS EMPRESA";
export const GET_COMPARTILHARDOCUMENTO = "[COMPARTILHAR APP] GET COMPARTILHAR DOCUMENTO";
export const COMPARTILHAR_WARNING = "[COMPARTILHAR APP] WARNING";
export const COMPARTILHAR_ERROR = "[COMPARTILHAR APP] ERROR";
export const COMPARTILHAR_INFO = "[COMPARTILHAR APP] INFO";

export function getCompartilharDocumento(_AParams, _AIDPessoaFormulario) {

    return (dispatch, getState) => {
        let AUsuario = getState().auth.user.data.usuario;
        var AActions = [];
        var AConditionsAND = [{ "Campo": "pessoaformulario.formulario->>''uid''", "Operador": "!=", "Valor": AUsuario }];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "ProfissionaisEmpresa", AActions, "spvwempresapessoafuncionarioatendimento", ["*"], "SELECIONAR", AConditionsAND);
        AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "CompartilharDocumentos", AActions, "spvwpessoacompartilhardocumento", ["*"], "SELECIONAR", AConditionsAND);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_PROFISSIONAISEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_COMPARTILHARDOCUMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: COMPARTILHAR_ERROR,
                    payload: error
                });
            });
    };
}

export function saveCompartilharDocumento(_AState, _AParams) {
    return (dispatch) => {
        var AActions = [];

        if (!_AState.formulario) {
            _AState.formulario = {};
        }
        _AState.formulario[_AState.idprofissional] = _AState.selected;

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", "INSERIR-COMPARTILHAR-DOCUMENTO", _AState, "", [], [], 1);
        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionpessoaformulario", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: COMPARTILHAR_WARNING,
                            payload: response.warning
                        })
                    ]);
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: COMPARTILHAR_INFO,
                            payload: response.info
                        })
                    ]);
                }
            }
            ).catch(error => {
                return dispatch({
                    type: COMPARTILHAR_ERROR,
                    payload: error
                });
            });
    };
}